module.exports = __webpack_public_path__ + "static/logo-2019-6b0fd18fe04fb0ace1ded6049971e47c.png";